module.exports = __webpack_public_path__ + "dcd25f962daeb231b9bced71c9558b37.png";